<template>
    <div class="client-single">
        <div class="m-content">
            <div class="row">
                <div class="col-12 col-lg-7">

                    <!--Begin::Portlet-->
                    <div class="m-portlet  m-portlet--full-height ">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        Kunden Verlauf
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body">
                            <timeline :timeline-arr="timelineArr"></timeline>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-5">

                    <div class="m-portlet">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        Stammdaten
                                    </h3>
                                </div>
                            </div>
                            <div class="m-portlet__head-tools">
                                <ul class="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm" role="tablist"
                                    style="min-width: 220px; justify-content: end;"
                                >
                                    <li class="nav-item m-tabs__item">
                                        <button @click="syncHubspotData()" class="btn btn-primary" type="button"
                                                :disabled="isSyncingHubspotData || !(client.user && client.user.hubspot_id > 0)"
                                        >
                                            Sync
                                        </button>
                                    </li>
                                    <li class="nav-item m-tabs__item">
                                        <a class="nav-link m-tabs__link btn-hubspot" data-toggle="tab" :href="'https://app-eu1.hubspot.com/contacts/25794910/company/' + client.hubspot_id" role="tab">
                                            Zu Hubspot
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="m-portlet__body">

                            <!--begin::Content-->
                            <div class="tab-content">
                                <div class="tab-pane active" :id="'m_widget5_tab1_content_client'" aria-expanded="true">
                                    <div>
                                        <div class="m-portlet__padding-x">
                                            <div class="">
                                                <div class="">
                                                    <div >
                                                        <div>
                                                            <div>
                                                                {{ client.company }}
                                                            </div>
                                                            <div>{{ client.company }}</div>

                                                            <div class="">KONTAKT:</div>
                                                            <div class="">{{ client.user.salutation }} {{ client.user.pre_name }} {{ client.user.name }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="m-demo-icon">
                                                <div class="m-demo-icon__preview">
                                                    <i class="fa fa-at"></i>
                                                </div>
                                                <div class="m-demo-icon__class">{{ client.main_mail }}</div>
                                            </div>
                                            <div class="m-demo-icon">
                                                <div class="m-demo-icon__preview">
                                                    <i class="fa fa-phone"></i>
                                                </div>
                                                <div class="m-demo-icon__class">{{ client.phone }}<span v-if="client.mobile != ''"><br />{{ client.mobile }}</span></div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="m-demo-icon">
                                                <div class="m-demo-icon__preview">
                                                    <i class="fa fa-home"></i>
                                                </div>
                                                <div class="m-demo-icon__class">{{ client.street }}<br />{{ client.additional_1 }}<br v-if="client.additional_1 != ''" />{{ client.additional_2 }}<br v-if="client.additional_2 != ''" />{{ client.zip }} {{ client.city }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--end::Content-->
                        </div>
                    </div>
                    <!--begin::Portlet-->
                    <div v-if="false" class="m-portlet m-portlet--accent m-portlet--head-solid-bg m-portlet--head-sm" m-portlet="true" id="m_portlet_tools_new">
                        <div class="m-portlet__head" @click="addNewProjectTemplate()">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
												<span class="m-portlet__head-icon">
													<i class="la la-list-ul"></i>
												</span>
                                    <h3 class="m-portlet__head-text">
                                        Neue Projekt Vorlage
                                    </h3>
                                </div>
                            </div>
                            <div class="m-portlet__head-tools">
                                <ul class="m-portlet__nav">
                                    <li class="m-portlet__nav-item">
                                        <a class="m-portlet__nav-link m-portlet__nav-link--icon"><i class="la la-plus"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-for="(projectTemplate, projectTemplateKey) in projectTemplates" class="m-portlet m-portlet--brand m-portlet--head-solid-bg m-portlet--head-sm" m-portlet="true" id="m_portlet_tools_1">
                        <div class="m-portlet__head" @click="projectTemplate.editClientDataToggle = !projectTemplate.editClientDataToggle">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
												<span class="m-portlet__head-icon">
													<i class="flaticon-user"></i>
												</span>
                                    <h3 v-if="projectTemplate.id == 0" class="m-portlet__head-text">
                                        Projekt Vorlage
                                    </h3>
                                    <h3 v-else class="m-portlet__head-text">
                                        {{ projectTemplate.name }}
                                    </h3>
                                </div>
                            </div>
                            <div class="m-portlet__head-tools">
                                <ul class="m-portlet__nav">
                                    <li class="m-portlet__nav-item">
                                        <a class="m-portlet__nav-link m-portlet__nav-link--icon"><i v-if="projectTemplate.editClientDataToggle" class="la la-angle-up"></i><i v-else class="la la-angle-down"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="m-portlet__body" :class="{ 'd-none' : !projectTemplate.editClientDataToggle }">
                            <form method="POST" class="m-form m-form--fit m-form--label-align-right">
                                <div class="m-portlet__body">
                                    <div class="form-group m-form__group row">
                                        <label for="projectTemplateName" class="col-3 col-form-label">
                                            Vorlage Titel
                                        </label>
                                        <div class="col-9">
                                            <input class="form-control m-input" type="text" v-model="projectTemplate.name" id="projectTemplateName" name="projectTemplateName">
                                        </div>
                                    </div>

                                    <div class="form-group m-form__group row">
                                        <label for="projectTemplateName" class="col-3 col-form-label">
                                            Format / Auflösung
                                        </label>
                                        <div class="col-9">
                                            <input class="form-control m-input" type="text" v-model="projectTemplate.scale" id="projectTemplateScale" name="projectTemplateScale">
                                        </div>
                                    </div>

                                    <div class="form-group m-form__group row">
                                        <label for="projectTemplateName" class="col-3 col-form-label">
                                            Schwierigkeitsgrad
                                        </label>
                                        <div class="col-9">
                                            <select v-model="projectTemplate.difficulty" class="form-control m-input">
                                                <option value="1">sehr einfach</option>
                                                <option value="2">einfach</option>
                                                <option value="3">normal</option>
                                                <option value="4">schwer</option>
                                                <option value="5">sehr schwer</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group m-form__group row">
                                        <label for="projectTemplateName" class="col-3 col-form-label">
                                            Kategorie
                                        </label>
                                        <div class="col-9">
                                            <select v-model="projectTemplate.category_id" class="form-control m-input">
                                                <option value="0">Bitte wählen</option>
                                                <option v-for="(category, key) in categoriesArr" :value="key">{{ category }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-group m-form__group row m--margin-top-5">
                                        <div class="col-9 offset-3">
                                            <div class="m-checkbox-inline">
                                                <label class="m-checkbox m-checkbox--square">
                                                    <input type="checkbox" v-model="projectTemplate.jpg"> JPG
                                                    <span></span>
                                                </label>
                                                <label class="m-checkbox m-checkbox--square">
                                                    <input type="checkbox" v-model="projectTemplate.png"> PNG
                                                    <span></span>
                                                </label>
                                                <label class="m-checkbox m-checkbox--square">
                                                    <input type="checkbox" v-model="projectTemplate.psd"> PSD
                                                    <span></span>
                                                </label>
                                                <label class="m-checkbox m-checkbox--square">
                                                    <input type="checkbox" v-model="projectTemplate.tiff"> TIFF
                                                    <span></span>
                                                </label>
                                                <label class="m-checkbox m-checkbox--square">
                                                    <input type="checkbox" v-model="projectTemplate.withMirror"> Spiegelung
                                                    <span></span>
                                                </label>
                                                <label class="m-checkbox m-checkbox--square">
                                                    <input type="checkbox" v-model="projectTemplate.withShadow"> Schatten
                                                    <span></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group m-form__group row">
                                        <label for="projectTemplateName" class="col-3 col-form-label">
                                            Notiz
                                        </label>
                                        <div class="col-9">
                                            <textarea class="form-control m-input" rows="3" v-model="projectTemplate.description" id="projectTemplateDescription" name="projectTemplateDescription"></textarea>
                                        </div>
                                    </div>

                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th width="60">Anzahl</th>
                                            <th>Typ</th>
                                            <th>Beschreibung</th>
                                            <th width="100">Preis</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="task in projectTemplate.taskArr">
                                            <td><input class="form-control m-input" type="text" v-model="task.quantity"></td>
                                            <td>
                                                <select class="form-control m-input m-input--square" v-model="task.type">
                                                    <option v-for="(taskType, key) in taskTypeArr" :value="key">{{ taskType }}</option>
                                                </select>
                                            </td>
                                            <td><input class="form-control m-input" type="text" v-model="task.name"></td>
                                            <td><input class="form-control m-input" type="number" v-model="task.price" step="0.01"></td>
                                        </tr>

                                        </tbody>
                                    </table>
                                    <div class="d-flex justify-content-end"><button type="button" @click="addNewTask(projectTemplateKey)" class="btn btn-success m-btn m-btn--custom m-btn--bolder m-btn--uppercase"><i class="la la-plus"></i></button></div>
                                </div>
                                <div class="m-portlet__foot m-portlet__foot--fit">
                                    <div class="m-form__actions">
                                        <button @click="saveProjectTemplate(projectTemplateKey)" class="btn btn-primary" type="button">
                                            SPEICHERN
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="m-portlet m-portlet--accent m-portlet--head-solid-bg m-portlet--head-sm" m-portlet="true" id="m_portlet_tools_note">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                                    <span class="m-portlet__head-icon">
                                                        <i class="la la-list-ul"></i>
                                                    </span>
                                    <h3 class="m-portlet__head-text">
                                        Kunden Notiz
                                    </h3>
                                </div>
                            </div>

                            <div class="m-portlet__head-tools">
                                <ul class="m-portlet__nav">
                                    <li class="m-portlet__nav-item">
                                        <a class="m-portlet__nav-link m-portlet__nav-link--icon"><i class="la la-plus"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="m-portlet__body">
                            <form method="POST" class="m-form m-form--fit m-form--label-align-right">
                                <textarea id="js-client-note-summernote" name="client-note">{{ client.note }}</textarea>
                                <button type="button" class="btn btn-brand mt-2" @click="saveNote()">Speichern</button>
                            </form>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row m-row--col-separator-xl" v-if="statistikData.doneArr && statistikData.doneArr.projectArr">
                <project-stats class="col-xl-4" v-for="project in statistikData.doneArr.projectArr" :project="project" :key="project.id"></project-stats>
            </div>
        </div>
    </div>

</template>
<script>

    import ProjectStats from "./client/ProjectStats";
    import Timeline from "./Timeline";
    export default {
        name: 'client-single',
        props: {
            client: Object,
            statistikData: Object,
            timelineArr: Object,
            clientGroupArr: Array,
            commissionGroupArr: Array,
            projectTemplateArr: Array,
            categoriesArr: Array,
            taskTypeArr: Object,
            isSyncingHubspotData: Boolean,
        },
        components: {
            Timeline,
            ProjectStats
        },
        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                projectTemplates:[]
            }
        },
        mounted() {
            $(document).ready(function(){
                $("#js-client-note-summernote").summernote({
                    height: 450,
                });
            });
        },
        watch: {
        },
        methods: {
            saveNote(){
                this.client.note = $("#m_portlet_tools_note .note-editable").html();

                $.ajax({
                    url :'/client-update-note-' + this.client.id,
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: { clientNote: this.client.note },
                    success:  (data) => {
                        console.log(data);
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });

            },
            addNewProjectTemplate(){
                let tmpProductTemplate = {
                    id: 0,
                    editClientDataToggle: false,
                    name: "",
                    description: "",
                    guideline: "",
                    withShadow: false,
                    withMirror: false,
                    jpg: false,
                    png: false,
                    psd: false,
                    tiff: false,
                    scale: "2000x2000 - 72dpi",
                    difficulty: 3,
                    category_id: 0,
                    taskArr:[]
                };
                let taskTemplate = {
                    quantity: 1,
                    type: 1,
                    name: "Produktbilder",
                    price: 0
                }
                this.projectTemplates.push(tmpProductTemplate);
                this.projectTemplates[this.projectTemplates.length - 1].taskArr.push(taskTemplate);
            },
            addNewTask(projectTemplateKey){
                let taskTemplate = {
                    quantity: 1,
                    type: 1,
                    name: "Produktbilder",
                    price: 0
                }
                this.projectTemplates[projectTemplateKey].taskArr.push(taskTemplate);
            },
            saveProjectTemplate(projectTemplateKey){
                $.ajax({
                    url :'/save-project-template',
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: { client: this.client, projectTemplate: this.projectTemplates[projectTemplateKey] },
                    success:  (data) => {
                        this.projectTemplates[projectTemplateKey] = JSON.parse(data);
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            },
            syncHubspotData(){
                this.isSyncingHubspotData = true;
                $.ajax({
                    url : `/kunde-${this.client.id}/sync-hubspot-data`,
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success:  (data) => {
                        console.log('sync done');
                        location.reload();
                        this.isSyncingHubspotData = false;
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        this.isSyncingHubspotData = false;
                        alert('Es ist ein Problem aufgetreten. Prüfen Sie, ob die E-Mail in den neuen Daten ggf. einem anderen Kontakt zugeordnet ist und falls ja, synchronisieren Sie diesen vorher!');
                    }
                });
            }
        }
    }
</script>
